export default __webpack_public_path__ + "assets/images/f2436af5571e059b6e6cc22c7afdd4a2.png";